import { lazy, Suspense, type ComponentType } from "react";

/**
 * A route component loaded on first use. Every chunk is precached by the service worker, so
 * this only shortens startup: it never needs the network (SPEC §11.4).
 */
export function lazyPage<M extends Record<string, unknown>>(
  load: () => Promise<M>,
  name: keyof M & string,
): ComponentType {
  const Component = lazy(async () => ({ default: (await load())[name] as ComponentType }));
  function LazyPage() {
    return (
      <Suspense fallback={null}>
        <Component />
      </Suspense>
    );
  }
  LazyPage.displayName = `Lazy(${name})`;
  return LazyPage;
}
